module.exports = __webpack_public_path__ + "static/media/search.87702de3.svg";